<template>
  <div class="contact-link">
    <div class="contact-link__name">{{form.name}}</div>
    <div class="contact-link__form">
      <div>
        <text-input v-model="form.label" @input="emit" />
      </div>
      <div>
        <div class="contact-link__action">
          <select-input v-model="form.type" :options="typeOptions" @input="emit" />
        </div>
        <div class="contact-link__url">
          <text-input v-model="form.url" @input="emit" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TextInput from '@/components/TextInput.vue';
import SelectInput from '@/components/SelectInput.vue';

export default {
  name: 'ContactLink',
  components: {
    TextInput,
    SelectInput,
  },
  props: {
    label: String,
    name: String,
    type: String,
    url: String,
  },
  data() {
    return {
      form: { ...this.$props },
      typeOptions: [{
        key: '',
        value: '',
        label: 'No action',
      }, {
        key: 'href',
        value: 'href',
        label: 'Link to',
      }, {
        key: 'mailto',
        value: 'mailto',
        label: 'Open email',
      }],
    };
  },
  created() {
    this.emit();
  },
  methods: {
    emit() {
      this.$emit('input', this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
.contact-link {
  padding: 20px;
  background: rgba(0,0,0,0.02);
  border-radius: var(--radius);
  margin-bottom: 20px;
  width: 100%;
  display: flex;
  &__name {
    width: 120px;
    text-align: left;
  }
  &__form {
    flex: 1;
    > div {
      display: flex;
      align-items: center;
      width: 100%;
      margin-bottom: 10px;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
  &__action {
    width: 150px;
    margin-right: 10px;
  }
  &__url {
    flex: 1;
  }
}
</style>
